export const appDownloadsConfig = {
  desktop: {
    url: import.meta.env.VITE_DESKTOP_APP_DOWNLOAD_URL || '',
  },
  mobile: {
    url: import.meta.env.VITE_MOBILE_APP_DOWNLOAD_URL || '',
  },
}
